// extracted by mini-css-extract-plugin
module.exports = {"container":"Section1_container__bwh1R","limiter":"Section1_limiter__2yRuT","wrapper":"Section1_wrapper__3f_TD","logo":"Section1_logo__2KePC"};